import React from 'react';
import Contact_Popup from '../Components/Contact_Popup';
import Right_Pannel from '../Components/Right_Pannel';
import Header from '../Components/Header';
import Left_Intro from '../Components/Left_Intro.js';



function Contact() {
  return (
    <>
      <title>Contact | Akshat Srivastava</title>

      <meta
        name="description"
        content="Contact Akshat Srivastava for inquiries, collaborations, or to learn more about his software development and design expertise."
      />

      <meta
        name="keywords"
        content="Akshat Srivastava Contact, Software Development, UI/UX Design, Portfolio, React, Java, Python, Figma"
      />

      <link
        rel="canonical"
        href="https://akshat-srivastava-navy.vercel.app/contact"
      />

      {/* Open Graph */}
      <meta property="og:title" content="Contact | Akshat Srivastava" />
      <meta
        property="og:description"
        content="Contact Akshat Srivastava for inquiries, collaborations, or to learn more about his software development and design expertise."
      />
      <meta property="og:type" content="contact" />

      <div className="bg-default h-screen">
        <Header />
        <div className="md:flex md:px-28">
          <Left_Intro />
          <div className="flex-1 w-full overflow-hidden">
            <Contact_Popup />
          </div>
          <div className="hidden sticky md:block">
            <Right_Pannel />
          </div>
        </div>

        <div className="block md:hidden">
          <Right_Pannel />
        </div>
      </div>
    </>
  );
}

export default Contact;
